// extracted by mini-css-extract-plugin
export var linkText = "_mz-0";